import {
  PRODUCT_COMMENTS_REQUESTED,
  PRODUCT_COMMENTS_RETRIEVED,
  PRODUCT_COMMENTS_FAILED,
  PARENT_COMMENT_POST_REQUESTED,
  PARENT_COMMENT_POST_SUCCESSFULL,
  PARENT_COMMENT_POST_ERRORED,
  CHILD_COMMENT_POST_REQUESTED,
  CHILD_COMMENT_POST_SUCCESSFULL,
  CHILD_COMMENT_POST_ERRORED,
  SEEN_SELLER_COMMENTS_REQUESTED,
  SEEN_SELLER_COMMENTS_RETRIEVED,
  SEEN_SELLER_COMMENTS_FAILED,
  UNSEEN_SELLER_COMMENTS_REQUESTED,
  UNSEEN_SELLER_COMMENTS_RETRIEVED,
  UNSEEN_SELLER_COMMENTS_FAILED,
  SEEN_BUYER_COMMENTS_REQUESTED,
  SEEN_BUYER_COMMENTS_RETRIEVED,
  SEEN_BUYER_COMMENTS_FAILED,
  UNSEEN_BUYER_COMMENTS_REQUESTED,
  UNSEEN_BUYER_COMMENTS_RETRIEVED,
  UNSEEN_BUYER_COMMENTS_FAILED,
  COMMENT_REQUESTED,
  COMMENT_RETRIEVED,
  COMMENT_FAILED,
  MARK_COMMENT_SEEN_REQUESTED,
  MARK_COMMENT_SEEN_SUCCESSFULL,
  MARK_COMMENT_SEEN_FAILED
} from './types';
import CommentsRestClient from '../../http/client/Comments';

export const getProductComments = (product, offset = 0, pageSize) => {
  const requested = () => ({ type: PRODUCT_COMMENTS_REQUESTED, offset });
  const successfull = response => ({
    type: PRODUCT_COMMENTS_RETRIEVED,
    comments: response.data,
    product,
    hasMoreComments: response.data.length === pageSize
  });
  const errored = error => ({ type: PRODUCT_COMMENTS_FAILED, error });

  return dispatch => {
    dispatch(requested());

    return CommentsRestClient.fetchProductComments(product, offset, pageSize)
      .then(response => dispatch(successfull(response)))
      .catch(error => dispatch(errored(error.response)));
  };
};

export const postParentComment = (product, comment) => {
  const requested = () => ({ type: PARENT_COMMENT_POST_REQUESTED });
  const successfull = response => ({
    type: PARENT_COMMENT_POST_SUCCESSFULL,
    comment: response.data
  });
  const errored = error => ({ type: PARENT_COMMENT_POST_ERRORED, error });

  return dispatch => {
    dispatch(requested());

    return CommentsRestClient.postParentComment(product, comment)
      .then(response => dispatch(successfull(response)))
      .catch(error => dispatch(errored(error.response)));
  };
};

export const getSellerComments = (filter = 'seen', offset, pageSize) => {
  const requested = () => ({
    type:
      filter === 'seen'
        ? SEEN_SELLER_COMMENTS_REQUESTED
        : UNSEEN_SELLER_COMMENTS_REQUESTED
  });
  const successfull = response => ({
    type:
      filter === 'seen'
        ? SEEN_SELLER_COMMENTS_RETRIEVED
        : UNSEEN_SELLER_COMMENTS_RETRIEVED,
    sellerComments: response.data
  });
  const errored = error => ({
    type:
      filter === 'seen'
        ? SEEN_SELLER_COMMENTS_FAILED
        : UNSEEN_SELLER_COMMENTS_FAILED,
    error
  });

  return dispatch => {
    dispatch(requested());

    return CommentsRestClient.fetchSellerComments(filter, offset, pageSize)
      .then(response => dispatch(successfull(response)))
      .catch(error => dispatch(errored(error.response)));
  };
};

export const getBuyerComments = (filter = 'seen', offset, pageSize) => {
  const requested = () => ({
    type:
      filter === 'seen'
        ? SEEN_BUYER_COMMENTS_REQUESTED
        : UNSEEN_BUYER_COMMENTS_REQUESTED
  });
  const successfull = response => ({
    type:
      filter === 'seen'
        ? SEEN_BUYER_COMMENTS_RETRIEVED
        : UNSEEN_BUYER_COMMENTS_RETRIEVED,
    buyerComments: response.data
  });
  const errored = error => ({
    type:
      filter === 'seen'
        ? SEEN_BUYER_COMMENTS_FAILED
        : UNSEEN_BUYER_COMMENTS_FAILED,
    error
  });

  return dispatch => {
    dispatch(requested());

    return CommentsRestClient.fetchBuyerComments(filter, offset, pageSize)
      .then(response => dispatch(successfull(response)))
      .catch(error => dispatch(errored(error.response)));
  };
};

export const getComment = comment => {
  const requested = () => ({ type: COMMENT_REQUESTED, comment });
  const successfull = response => ({
    type: COMMENT_RETRIEVED,
    comment,
    conversation: response.data
  });
  const errored = error => ({ type: COMMENT_FAILED, error, comment });

  return dispatch => {
    dispatch(requested());

    return CommentsRestClient.fetchComment(comment)
      .then(response => dispatch(successfull(response)))
      .catch(error => dispatch(errored(error.response)));
  };
};

export const createChildComment = (parentComment, comment) => {
  const requested = () => ({ type: CHILD_COMMENT_POST_REQUESTED });
  const successfull = response => ({
    type: CHILD_COMMENT_POST_SUCCESSFULL,
    parentComment,
    comment: response.data
  });
  const errored = error => ({ type: CHILD_COMMENT_POST_ERRORED, error });

  return dispatch => {
    dispatch(requested());
    return CommentsRestClient.createChildComment(parentComment, comment)
      .then(response => dispatch(successfull(response)))
      .catch(error => dispatch(errored(error.response)));
  };
};

export const markCommentAsSeen = parentComment => {
  const requested = () => ({ type: MARK_COMMENT_SEEN_REQUESTED });
  const successfull = response => ({
    type: MARK_COMMENT_SEEN_SUCCESSFULL,
    parentComment
  });
  const errored = error => ({ type: MARK_COMMENT_SEEN_FAILED, error });

  return dispatch => {
    dispatch(requested());
    return CommentsRestClient.markCommentAsSeen(parentComment)
      .then(response => dispatch(successfull(response)))
      .catch(error => dispatch(errored(error.response)));
  };
};
